<template>
  <div class="step2">
    <info-panel class="info">
      <span class="avatar">
        <img :src="info.wechatAvatarUrl">
      </span>
      <span class="info-item">
        手机号码:<b>{{ info.mobilePhone }}</b>
      </span>
      <span class="info-item">
        真实姓名:<b>{{ info.realName }}</b>
      </span>
    </info-panel>
    <form-title>基本信息</form-title>
    <info-panel>
      <el-form
        ref="creatStep2Form"
        :model="creatStep2Form"
        :rules="creatStep2Rules"
        label-width="140px"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="资质照片"
              prop="qualificationPic"
            >
              <upload
                :file-list.sync="creatStep2Form.qualificationPic"
                :limit="5"
              />
              <el-input
                v-show="false"
                v-model="creatStep2Form.qualificationPic"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="讲师证/教师资格证"
              prop="certificatePic"
            >
              <upload
                :file-list.sync="creatStep2Form.certificatePic"
                :limit="5"
              />
              <el-input
                v-show="false"
                v-model="creatStep2Form.certificatePic"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="技能证书"
              prop="skillsPic"
            >
              <upload
                :file-list.sync="creatStep2Form.skillsPic"
                :limit="5"
              />
              <el-input
                v-show="false"
                v-model="creatStep2Form.skillsPic"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="绑定课程"
              prop="courseList"
            >
              <el-select
                v-model="creatStep2Form.courseList"
                placeholder="请选择绑定课程"
                multiple
                filterable
                clearable
              >
                <el-option
                  v-for="item in courseList"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col class="btns">
            <el-button
              :disabled="isEdit"
              @click="prev"
            >
              上一步
            </el-button>
            <el-button
              type="primary"
              @click="next"
            >
              保存
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </info-panel>
  </div>
</template>
<script>
import infoPanel from '@/components/common/infoPanel.vue';
import formTitle from '@/components/common/formTitle.vue';
// import types from '@/config';
import upload from '@/components/common/upload/upload.vue';
import axClient from '@/services';

export default {
  name: 'CreatStep1',
  components: { infoPanel, formTitle, upload },
  props: {
    info: {
      default: () => ({
        id: '',
        mobilePhone: '',
        realName: '',
        wechatAvatarUrl: '',
      }),
      type: Object,
    },
    form: {
      default: () => ({
        qualificationPic: '',
        certificatePic: '',
        skillsPic: '',
        courseList: [], // 绑定课程
        userId: '',
      }),
      type: Object,
    },
  },
  data() {
    return {
      isEdit: !!this.$route.params.id,
      creatStep2Form: {
        qualificationPic: '',
        certificatePic: '',
        skillsPic: '',
        courseList: [], // 绑定课程
      },
      courseList: [], // 课程列表
      creatStep2Rules: {
        qualificationPic: [
          { required: true, message: '请输入资质照片', trigger: 'blur' },
        ],
        certificatePic: [
          { required: true, message: '请输入教师资格证', trigger: 'blur' },
        ],
      },
    };
  },
  mounted() {
    if (this.isEdit) {
      this.creatStep2Form = { ...this.form };
    }
    this.getCourseList();
  },
  methods: {
    getFilePath0(path) {
      this.creatStep2Form.qualificationPic = path;
    },
    getFilePath1(path) {
      this.creatStep2Form.certificatePic = path;
    },
    getFilePath2(path) {
      this.creatStep2Form.skillsPic = path;
    },
    // 上一步
    prev() {
      this.$emit('prev', 1);
    },
    // 提交
    next() {
      this.$refs.creatStep2Form.validate(async (valid) => {
        if (valid) {
          this.$emit('next', this.creatStep2Form);
        }
      });
    },
    // 获取课程列表
    async getCourseList() {
      this.courseList = await axClient.points.listCourseClassName();
    },
  },
};
</script>
<style lang="scss" scoped>
.step2 {
  .info {
    display: flex;
    align-items: center;
    color: $--base-color-black;
    font-size: 14px;
    margin-bottom: 20px;
    .info-item {
      margin-left: 40px;
      b {
        margin-left: 10px;
      }
    }
    .avatar {
      img {
        border-radius: 50%;
        display: inline-block;
        width: 32px;
        height: 32px;
        background: #eee;
      }
    }
  }
}
</style>